import React, { useEffect, useState } from 'react';
import CSVReader from 'react-csv-reader';
import { BreakToAdd } from 'models/Break';

interface Props {
  onChange: (data: BreakToAdd[]) => void;
}

const CsvBreak: React.FC<Props> = ({ onChange }) => {
  const [data, setData] = useState<BreakToAdd[]>([]);
  useEffect(() => {
    onChange(data);
  }, [data]);
  const formatData = (_data: Array<Array<string>>): void => {
    const newArray = _data.slice(1, _data.length - 1);
    const header = _data[0];
    const formattedData: BreakToAdd[] = [];

    newArray.forEach((singleBreak: Array<string>) => {
      let breakType = {} as BreakToAdd;
      singleBreak.forEach((field: string, fieldId: number) => {
        header.forEach((singleHeader: string, headerId: number) => {
          if (
            singleHeader === 'title' ||
            singleHeader === 'provider' ||
            singleHeader === 'unitCost'
          ) {
            if (headerId === fieldId && field) {
              breakType = { ...breakType, [singleHeader]: field };
            }
          }
        });
      });

      formattedData.push(breakType);
    });
    setData(formattedData);
  };

  return (
    <CSVReader
      cssClass="btn btn btn-soft-light"
      onFileLoaded={formatData}
      inputId="BreakInput"
    />
  );
};

export default CsvBreak;
